import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from '../shared/ui/Icon';

const items: { to: string; label: string; icon: IconName }[] = [
  { to: '/', label: '主页', icon: 'home' },
  { to: '/materials', label: '样片素材', icon: 'materials' },
  { to: '/generate/image', label: 'AI生成', icon: 'ai' },
  { to: '/courses', label: '课程', icon: 'courses' },
  { to: '/me', label: '我的', icon: 'profile' }
];

export function BottomNav() {
  return <nav className="bottom-nav" aria-label="主导航">{items.map((item, index) => <NavLink key={item.to} to={item.to} end={index !== 2} className={({ isActive }) => `${index === 2 ? 'bottom-nav__ai ' : ''}${isActive ? 'is-active' : ''}`}><span className="bottom-nav__icon"><Icon name={item.icon} size={index === 2 ? 32 : 25} /></span><small>{item.label}</small></NavLink>)}</nav>;
}
